import createIcon from '../../createIcon';

/**
 * @component @name Tornado
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuMTEgNy41TDIzIDIuNUgxTDMuODkgNy41SDIwLjExWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTcuOTUgMTQuNUwxMiAyMS41TDE2LjA1IDE0LjVINy45NVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOC45NSA5LjVINS4wNUw2Ljc5IDEyLjVIMTcuMjFMMTguOTUgOS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Tornado = createIcon('Tornado', [
  ['path', { d: 'M20.11 7.5L23 2.5H1L3.89 7.5H20.11Z', key: '1je35x' }],
  ['path', { d: 'M7.95 14.5L12 21.5L16.05 14.5H7.95Z', key: '1wk6xh' }],
  ['path', { d: 'M18.95 9.5H5.05L6.79 12.5H17.21L18.95 9.5Z', key: 'q78aq0' }],
]);

export default Tornado;
